import { render, staticRenderFns } from "./QIAagentBanner.vue?vue&type=template&id=0f7ed693&scoped=true&"
var script = {}
import style0 from "./QIAagentBanner.vue?vue&type=style&index=0&id=0f7ed693&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7ed693",
  null
  
)

export default component.exports